import { EditMode, GCRMode, PageGroup } from "../../common/transaction"
import { FlightMode } from "../FlightAvailability"

const shlCodes = ["Y", "B", "V"]
const RCodes = ["I", "L"]
const offerCodes = ["F", "A", "P", "Z"]

const fieldTypes = {
  arrField: [
    "originStation",
    "clearedTimeArr",
    "serviceTypeArr",
    "operatorArr"
  ],
  depField: [
    "clearedTimeDep",
    "destinationStation",
    "serviceTypeDep",
    "terminalDep",
    "operatorDep"
  ],
  genericField: ["numSeats", "aircraftType"],
  dateField: ["doop", "endDate"],
  gabaRegFieldArr: ["serviceNoArr"],
  gabaRegFieldDep: ["serviceNoDep"]
}

export function handleGetType(id: string, types: Object): string {
  let type = null

  Object.keys(types).forEach((typeKey) => {
    const idExists = types[typeKey].find((a) => a === id)

    if (idExists) {
      type = typeKey
    }
  })
  return type
}

export interface TransactionItemFieldConfig {
  showField: {
    pageModule: { add: boolean; edit: boolean; response: boolean }
    flightMode: { A: boolean; D: boolean; T: boolean }
    gabaMode: { FLT: boolean; REG: boolean }
  }
  editable: {
    pageModule: { add: boolean; edit: boolean; response: boolean }
    actionCode: {
      D: boolean
      C: boolean
      R: boolean
      N: boolean
      FAPZ: boolean
    }
  }
  showSection: {
    pageModule: { add: boolean; edit: boolean; response: boolean }
    pageGroup: {
      series: boolean
      gaba: boolean
      singleDate: boolean
      shl: boolean
      offers: boolean
      handling: boolean
    }
    handlingApp?: {
      FRAPORTGR?: boolean
    }
  }
}

export interface TransactionItemFieldMap {
  [fieldName: string]: TransactionItemFieldConfig
}

const transactionItemFields: TransactionItemFieldMap = {
  arrField: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  depField: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: false, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  terminalArr: {
    showField: {
      pageModule: { add: false, edit: false, response: false },
      flightMode: { A: true, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: false, edit: false, response: false },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  gabaRegFieldArr: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: false, T: true },
      gabaMode: { FLT: true, REG: false }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  gabaRegFieldDep: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: false, D: true, T: true },
      gabaMode: { FLT: true, REG: false }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  lastStation: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: false,
        handling: false,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  nextStation: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: false, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: false,
        handling: false,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  minGroundTime: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: false, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  turnaroundDays: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: false, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: false,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  startDate: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: true, C: true, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  startDateSingle: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  departureDate: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: false, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: true, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  dateField: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: true, C: true, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: false,
        handling: false,
        singleDate: false,
        shl: true,
        offers: true
      }
    }
  },
  genericField: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  woop: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: false,
        handling: false,
        singleDate: false,
        shl: true,
        offers: true
      }
    }
  },
  airport: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: false, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  requiredTimeArr: {
    showField: {
      pageModule: { add: false, edit: true, response: true },
      flightMode: { A: true, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: false, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: false, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  requiredTimeDep: {
    showField: {
      pageModule: { add: false, edit: true, response: true },
      flightMode: { A: false, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: false, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: false, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  reasonCodeArr: {
    showField: {
      pageModule: { add: false, edit: true, response: true },
      flightMode: { A: true, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: false, edit: false, response: false },
      actionCode: { D: false, C: false, R: false, N: false, FAPZ: false }
    },
    showSection: {
      pageModule: { add: false, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      },
      handlingApp: { FRAPORTGR: false }
    }
  },
  reasonCodeDep: {
    showField: {
      pageModule: { add: false, edit: true, response: true },
      flightMode: { A: false, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: false, edit: false, response: false },
      actionCode: { D: false, C: false, R: false, N: false, FAPZ: false }
    },
    showSection: {
      pageModule: { add: false, edit: true, response: true },
      pageGroup: {
        series: true,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: true,
        offers: true
      },
      handlingApp: { FRAPORTGR: false }
    }
  },
  offerTimeArr: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: false, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: false },
      pageGroup: {
        series: true,
        gaba: true,
        handling: false,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  offerTimeDep: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: false, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: false },
      pageGroup: {
        series: true,
        gaba: true,
        handling: false,
        singleDate: true,
        shl: true,
        offers: true
      }
    }
  },
  requestCode: {
    showField: {
      pageModule: { add: true, edit: false, response: false },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: false, REG: false }
    },
    editable: {
      pageModule: { add: true, edit: false, response: false },
      actionCode: { D: false, C: false, R: false, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: false, response: false },
      pageGroup: {
        series: false,
        gaba: false,
        handling: false,
        singleDate: false,
        shl: true,
        offers: false
      }
    }
  },
  aircraftRegistration: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: true,
        handling: true,
        singleDate: true,
        shl: false,
        offers: true
      }
    }
  },
  handler: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },

  requiredDateArr: {
    showField: {
      pageModule: { add: false, edit: true, response: true },
      flightMode: { A: false, D: false, T: true },
      gabaMode: { FLT: false, REG: false }
    },
    editable: {
      pageModule: { add: false, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: false, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  requiredDateDep: {
    showField: {
      pageModule: { add: false, edit: true, response: true },
      flightMode: { A: false, D: false, T: true },
      gabaMode: { FLT: false, REG: false }
    },
    editable: {
      pageModule: { add: false, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: false, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },

  parkingLocation: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: true,
        handling: false,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  vfr: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  towbar: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  refuelling: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  gabaLounge: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  mtow: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  operatorText: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: true,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  },
  noiseCertificate: {
    showField: {
      pageModule: { add: true, edit: true, response: true },
      flightMode: { A: true, D: true, T: true },
      gabaMode: { FLT: true, REG: true }
    },
    editable: {
      pageModule: { add: true, edit: true, response: false },
      actionCode: { D: false, C: false, R: true, N: true, FAPZ: false }
    },
    showSection: {
      pageModule: { add: true, edit: true, response: true },
      pageGroup: {
        series: false,
        gaba: false,
        handling: false,
        singleDate: false,
        shl: false,
        offers: false
      }
    }
  }
}

export function handleGetTransactionItemFieldsConfig(): TransactionItemFieldMap {
  return transactionItemFields
}

export function showField(
  fieldName: string,
  flightMode: string,
  editMode: EditMode,
  gabaMode: string
): boolean {
  const fieldType = handleGetType(fieldName, fieldTypes) ?? fieldName
  const showFieldGabaMode =
    gabaMode === ""
      ? true
      : transactionItemFields[fieldType].showField.gabaMode[gabaMode]

  return (
    transactionItemFields[fieldType].showField.flightMode[flightMode] &&
    transactionItemFields[fieldType].showField.pageModule[editMode] &&
    showFieldGabaMode
  )
}

export function showFieldSection(
  fieldName: string,
  editMode: EditMode,
  pageGroup: PageGroup,
  handlingApp?: string
): boolean {
  const fieldType = handleGetType(fieldName, fieldTypes) ?? fieldName
  const handlingAppConfig =
    transactionItemFields[fieldType].showSection.handlingApp && handlingApp
      ? transactionItemFields[fieldType].showSection.handlingApp[handlingApp] ??
        true
      : true

  return (
    transactionItemFields[fieldType].showSection.pageGroup[pageGroup] &&
    transactionItemFields[fieldType].showSection.pageModule[editMode] &&
    handlingAppConfig
  )
}

export function isFieldEditable(
  fieldName: string,
  code: string,
  editMode: EditMode
): boolean {
  const fieldType = handleGetType(fieldName, fieldTypes) ?? fieldName
  const actionCodeIsEditable = code
    ? transactionItemFields[fieldType].editable.actionCode[code] ??
      shlCodes.find((c) => c === code)
      ? true
      : RCodes.find((c) => c === code)
      ? transactionItemFields[fieldType].editable.actionCode.R
      : offerCodes.find((c) => c === code)
      ? transactionItemFields[fieldType].editable.actionCode.FAPZ
      : false
    : true
  return (
    actionCodeIsEditable &&
    transactionItemFields[fieldType].editable.pageModule[editMode]
  )
}

export function showOperatorField(
  fieldName: string,
  flightMode: string,
  editMode: EditMode,
  gabaMode: string,
  operators: string[]
): boolean {
  const fieldType = handleGetType(fieldName, fieldTypes) ?? fieldName
  const isRegMode = gabaMode === GCRMode.REG
  const isAddMode = editMode === EditMode.ADD

  const showRegField =
    isRegMode && isAddMode
      ? operators.length > 1
      : isRegMode && !isAddMode
      ? false
      : true
  const isRegTurnaroundDepField =
    gabaMode === GCRMode.REG &&
    editMode === EditMode.ADD &&
    flightMode === FlightMode.TURNAROUND &&
    transactionItemFields[fieldType].showField.flightMode.D

  return (
    showField(fieldName, flightMode, editMode, gabaMode) &&
    showRegField &&
    !isRegTurnaroundDepField
  )
}
